import axios from "axios";
import * as d3 from "d3";
import {colonAnnotation, fw_progressive_1way, numberFormat, responsivefy} from '../functions'

export default function (chart, divId, vizName, filterParam) {
    var size = chart.axisFontSize
    var fontSize = size + "px"
    var fontColor = chart.axisFontColor
    var axisLabelFontSize = chart.axisLabelFontSize + "px"
    //var tempVar = chart.tempVar
    var url = '/api/fetchDataWithParam/' + chart.data.datasqlId + '/' + vizName

    console.log("Chart vizName called:", vizName)

    axios.post(url, filterParam).then(response => {
        let data = response.data

        data.forEach(function (d) {
            d.dim1_name = new Date(d.dim1_name);
            d.metric1 = +d.metric1;
        });

        var dataXAxis = d3.nest()
            .key(d => {
                return d.dim1_name;
            })
            .key(d => {
                return d.dim2_name;
            })
            .rollup(v => {
                return d3.sum(v, d => {
                    return d.metric1;
                });
            })
            .entries(data);

        dataXAxis.forEach(y => {
            y.dim1_name = y.key;
            y.values.forEach(d => {
                d.dim2_name = d.key;
                d.metric1 = +d.value;
            });
            y.values.sort((a, b) => {
                return b.metric1 - a.metric1
            });
        });

        var mainCategoryList = dataXAxis[0].values.map(d => {
            return d.dim2_name;
        });

        // Set the x and y values
        var x1Scale = d3.scaleTime().range([0, chart.width]);
        var y1Scale = d3.scaleLinear().range([chart.height, 0]);

        var formatTime = d3.timeFormat("%Y-%m-%d");

        // Define the axes
        var x1AxisLabel = d3.axisBottom(x1Scale).tickFormat(formatTime);

        var y1AxisLabel = d3.axisLeft(y1Scale).ticks(10).tickFormat(numberFormat);

        //Define the line
        var dataline = d3.line()
            .x(function (d) {
                return x1Scale(d.dim1_name);
            })
            .y(function (d) {
                return y1Scale(d.metric1);
            });

        var svg = d3.select(divId).select("svg").remove();
        // Adds the canvas
        svg = d3.select(divId)
            .append("svg")
            .attr("width", chart.width + chart.margin.left + chart.margin.right)
            .attr("height", chart.height + 3 * chart.margin.top + chart.margin.bottom)
            .call(responsivefy)
            .attr("font", "Arial")
            .style("font-size", "14px")
            .append("g")
            .attr("transform", "translate(" + chart.margin.left + "," + chart.margin.top + ")");

        // Nest the entries by symbol
        var dNest = d3.nest().key(function (d) {
            return d.dim2_name;
        }).entries(data);

        // set the colour scale
        var metric1ColorScale = d3.scaleOrdinal(fw_progressive_1way);
        metric1ColorScale.domain(mainCategoryList);

        // Scale the range of the data
        x1Scale.domain(d3.extent(data, (d) => {
            return d.dim1_name;
        }));
        y1Scale.domain([0, d3.max(data, (d) => {
            return d.metric1;
        })]);

        // spacing for the legend
        var legendSpace = chart.width / dNest.length;

        console.warn(legendSpace)
        // Add the X Axis
        svg.append("g")
            .attr("class", "x axis")
            .attr("transform", "translate(0," + chart.height + ")")
            .call(x1AxisLabel)
            .selectAll('text')
            .style('font-size', axisLabelFontSize)
            .style('text-anchor', 'end')
            .attr("font-size", "12px")
            .attr('dx', '-.8em')
            .attr('dy', '-.20em')
            .attr('transform', 'rotate(-60)')

        svg.append('text')
            .attr('x', (chart.width / 2))
            .attr('y', chart.height + chart.margin.bottom + 10 * chart.axisLabelDistance)
            .style('fill', fontColor)
            .text(chart.x1AxisDisplayName)
            .style('font-size', fontSize)

        // Add the Y Axis
        svg.append("g")
            .attr("class", "y axis")
            .call(y1AxisLabel)
            .style("font-size", axisLabelFontSize)

        svg.append('text')
            .attr('transform', 'rotate(-90)')
            .attr('y', 0 - chart.margin.left + 5)
            .attr('x', 0 - (chart.height / 2) + 50)
            .attr("dy", ".71em")
            .style("text-anchor", "end")
            .style('fill', fontColor)
            .style('font-size', fontSize)
            .text(chart.y1AxisDisplayName)

        // Loop through each symbol / key
        dNest.forEach(function (d) {
            var lines = svg.append("path")
                .attr("class", "line")
                .style("stroke", function () { // Add the colours dynamically
                    return d.metric1ColorScale = metric1ColorScale(d.key);
                })
                .attr("id", 'tag' + d.key.replace(/\s+/g, '')) // assign ID
                .attr("stroke-width", 2)
                .attr("fill", "none")
                .attr("d", dataline(d.values))
            //.on('contextmenu',  contextMenu(downloadData)); //commented due to hardcoding

            console.warn(lines)

            // Add the dots for the tooltip
            /*d3.select(".d3-tip"+divId.id).remove(); // clear tooltip based on class of tip element // appended with divId to make it unique
            var y1tip = tooltip_class()

            y1tip.attr('class', 'd3-tip'+divId.id)
                .html((d) =>{
                    return "Day"+ colonAnnotation+ formatTime(d.dim1_name) + "<br/> Sales" +
                             "(" + d.dim2_name+")"+ colonAnnotation+ numberFormat(d.metric1)
                })

            svg.call(y1tip);*/

            d3.select("tooltip" + divId.id).remove(); // clear tooltip based on class of tip element
            var div = d3.select(divId).append('div').attr('class', 'tooltip')
                .attr('style', 'position: absolute; opacity: 0;')

            svg.selectAll("dot")
                .data(data)
                .enter()
                .append("circle")
                .attr("r", 5)
                .attr("cx", function (d) {
                    return x1Scale(d.dim1_name);
                })
                .attr("cy", function (d) {
                    return y1Scale(d.metric1);
                })
                .style("fill", function (d) {
                    return metric1ColorScale(d.dim2_name)
                })
                .attr("id", 'tag' + d.key.replace(/\s+/g, '')) // assign ID
                .on("mousemove", function (d) {
                    console.log(d3.event, d)
                    div.transition()
                        .duration(200)
                        .style("opacity", .9);
                    div.html("Day" + colonAnnotation + formatTime(d.dim1_name) + "<br/> Sales" +
                        "(" + d.dim2_name + ")" + colonAnnotation + numberFormat(d.metric1)
                    )
                        .style("left", (d3.event.layerX) + "px")
                        .style("top", (d3.event.layerY) + "px");
                })
                .on("mouseout", function () {
                    div.transition().style("opacity", 0)
                })
            //.on("mouseover", y1tip.show)
            //.on("mouseout", y1tip.hide)
            //.on('contextmenu',  contextMenu(downloadData)); //commented due to hardcoding

            // Add the Legend
            var y1legend = svg.selectAll('.legend')
                .data(metric1ColorScale.domain())
                .enter().append('g')
                .attr('class', 'legend')
                .attr("transform", function (d, i) {
                    return "translate(30," + i * 25 + ")";
                });

            y1legend.append('circle')
                .attr('cx', chart.width + chart.vizSpecific2)
                .attr('cy', chart.vizSpecific1 - 2)
                .attr('r', 5)
                .attr('fill', metric1ColorScale)

            y1legend.append('text')
                .attr('x', chart.width + chart.vizSpecific2 + 10)
                .attr('y', chart.vizSpecific1)
                .attr('dy', '.1em')
                .style('fill', metric1ColorScale)
                .text((d) => {
                    return d
                })
        });
    });
}
